<template>
  <div class="close-handle">
    <CloseButton :disabled="navigating" :on-click="close" class="p-2 pr-12" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      navigating: false,
    }
  },
  methods: {
    close() {
      this.navigating = true
      const from = this.$store.getters['tracking/from']
      if (from) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
  },
}
</script>

<style>
.close-handle {
  @apply fixed right-0 z-50 flex items-center rounded-sm rounded-tl rounded-bl text-black-000 shadow;
  bottom: 150px;
  background-color: rgba(125, 125, 125, 0.2);

  @screen md {
    @apply hidden;
  }

  @media (aspect-ratio: 3/4), (width: 1024px) and (height: 1366px) {
    @apply flex;
  }
}

.in-google-showcase .close-handle {
  @apply hidden;
}
</style>
